const THREE = require('three')
import scene from './scene'
import renderer from './renderer'
import {tileSize, numDraw} from './track-tiled/config'
import {config as gameConfig} from './config'

const far = tileSize * (numDraw - 2) * gameConfig.worldScale
export let fog = new THREE.Fog(renderer.getClearColor(), 0, far)
export default fog
scene.fog = fog


// WEBPACK FOOTER //
// ./src/components/game/fog.js